document.addEventListener("DOMContentLoaded", function () {
    if (typeof $.fn.slick === 'function') {
        // Banner Slider
        $('.bannern').slick({
            autoplay: true,
            arrows: false,
            dots: true,
            pauseOnHover: true,
            speed: 500,
            draggable: false,
            swipe: false,
            touchMove: false
        });

        // Announcement Slider
        $('.announcement-slider').slick({
            speed: 6000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            draggable: false,
            focusOnSelect: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
        });

        // Image Slider 2
        $('.imageslider2').slick({
            infinite: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '30px',
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        // FLXDX Slider
        $('.flxdx-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 600,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                },
            ],
        });

        // FLBOXX Slider
        $('.flboxx').slick({
            centerMode: true,
            autoplay: true,
            centerPadding: '0px',
            slidesToShow: 5,
            responsive: [
                {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                centerMode: false
            }
        },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '0px',
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '0px',
                        slidesToShow: 3,
                    },
                },
            ],
        });

        // Slider Single and Nav
        $('.slider-single').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav',
        });
        $('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            asNavFor: '.slider-single',
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: { dots: true, slidesToShow: 1 },
                },
            ],
        });

        $('.tabs').tabs({
            activate: function (event, ui) {
                var activeTab = ui.newTab.find('a');
                var inactiveTab = ui.oldTab.find('a');
                var tabcolor = activeTab.data('dark');
                var tabtextcolor = activeTab.data('text');
                $(inactiveTab).css({ 'background-color': '', color: '' });
                $(activeTab).css('background', tabcolor);
                $(activeTab).css({ 'background-color': tabcolor, color: tabtextcolor });
            },
        });

        // FLXDX Slider 3
        $('.flxdx-slider3').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 600,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                },
            ],
        });

        $(document).ready(function () {
            var $slider = $('.upsell-slider');
            var slideCount = $slider.find('.upsell-slide').length;

            if (slideCount > 1) {
                $slider.slick({
                    slidesToShow: 2.4,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2.4
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2.4
                            }
                        }
                    ]
                });
            } else {
                // Force full width if only one slide
                $slider.addClass('single-slide');
            }
        });



        var $comparisonSlider = $('.comparison-slider-wrapper');

        if ($comparisonSlider.length) {
            $comparisonSlider.on('init', function () {
                $(this).closest('.comparison-slider-section').removeClass('is-hidden').addClass('is-visible');
            });

            $comparisonSlider.slick({
                slidesToShow: 8,
                slidesToScroll: 1,
                infinite: false,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2.5,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }


    } else {
        console.error("Slick Carousel library not loaded.");
    }
});
